<template>
  <v-dialog
    v-model="dialogProps.visibilidade"
    max-width="600px"
    persistent
  >
    <v-card class="pa-5">
      <v-card-title>
        <v-row class="d-flex flex-column text-lg-center">
          <h4 class="headline primary--text text-no-wrap">
            {{ labelBtnAcao }} Idioma
          </h4>
          <span class="subtitle-1">Selecione o idioma e o seu nível de fluência em cada categoria</span>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="dialogProps.valid"
        >
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-autocomplete
                v-model="perfilIdioma.idioma"
                :items="idiomas"
                :rules="[(v) => !!v || 'Selecione um curso']"
                :search-input.sync="idiomaSearch"
                item-text="nome"
                label="Idioma"
                placeholder="Digite para pesquisar..."
                persistent-hint
                prepend-icon="local_library"
                required
                return-object
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        O idioma <strong class="secondary--text">{{ idiomaSearch }}</strong> não foi encontrado.
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              v-if="perfilIdioma.idioma && perfilIdioma.idioma.isOutro"
              cols="12"
            >
              <v-text-field
                v-model.trim="perfilIdioma.nomeIdiomaOutro"
                :rules="ruleNotEmpty"
                label="Nome do Idioma"
                prepend-icon="local_library"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="perfilIdioma.compreensao"
                :items="niveisIdioma"
                :rules="[v => !!v || 'Selecione o seu nivel de Compreensão']"
                item-text="text"
                item-value="id"
                label="Compreensão"
                prepend-icon="spatial_tracking"
                required
                return-object
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="perfilIdioma.escrita"
                :disabled="perfilIdioma.idioma.nome === 'LIBRAS'"
                :items="niveisIdioma"
                :label="perfilIdioma.idioma.nome === 'LIBRAS' ? 'Não se Aplica' : 'Escrita'"
                :rules="[v => !!v || 'Selecione o seu nivel de Escrita']"
                item-text="text"
                item-value="id"
                prepend-icon="create"
                required
                return-object
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="perfilIdioma.fala"
                :items="niveisIdioma"
                :rules="[v => !!v || 'Selecione o seu nivel de Fala']"
                item-text="text"
                item-value="id"
                label="Fala"
                prepend-icon="record_voice_over"
                required
                return-object
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="perfilIdioma.leitura"
                :disabled="perfilIdioma.idioma.nome === 'LIBRAS'"
                :items="niveisIdioma"
                :label="perfilIdioma.idioma.nome === 'LIBRAS' ? 'Não se Aplica' : 'Leitura'"
                :rules="[v => !!v || 'Selecione o seu nivel de Leitura']"
                item-text="text"
                item-value="id"
                prepend-icon="menu_book"
                required
                return-object
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row class="justify-end mr-4">
          <v-btn
            :disabled="!dialogProps.valid"
            class="mr-2"
            color="primary"
            @click="doAcao"
          >
            {{ labelBtnAcao }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click="dialogProps.visibilidade = false"
          >
            Cancelar
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const perfilIdiomaRepository = RepositoryFactory.get('perfilIdioma');

const DEFAULT_PERFIL_IDIOMA = () => ({
  id: null,
  perfil: null,
  idioma: { id: null, nome: null },
  compreensao: '',
  escrita: '',
  fala: '',
  leitura: '',
});

export default {
  name: 'DialogIdioma',

  props: {
    dialogProps: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      ruleNotEmpty: [(v) => (v && !!v.trim()) || 'Campo Obrigatório'],
      perfilIdioma: DEFAULT_PERFIL_IDIOMA(),
      idiomaSearch: '',
      niveisIdioma: [
        { id: 'POUCO', text: 'Pouco' },
        { id: 'RAZOAVEL', text: 'Razoável' },
        { id: 'BOM', text: 'Bom' },
      ],
    };
  },

  computed: {
    ...mapState({
      perfil: (state) => state.auth.usuario.perfil,
      idiomas: (state) => state.perfil.idiomas,
    }),

    labelBtnAcao() {
      if (this.dialogProps.acao === 'editar') {
        return 'Editar';
      }
      if (this.dialogProps.acao === 'cadastrar') {
        return 'Adicionar';
      }
      return null;
    },
  },

  watch: {
    'dialogProps.visibilidade': function (visibilidade) {
      if (visibilidade) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.dialogProps.acao === 'editar') {
          this.perfilIdioma = JSON.parse(
            JSON.stringify(this.dialogProps.perfilIdioma),
          );
        }

        if (this.dialogProps.acao === 'cadastrar') {
          this.perfilIdioma = DEFAULT_PERFIL_IDIOMA();
        }
      } else {
        this.perfilIdioma = DEFAULT_PERFIL_IDIOMA();
      }
    },
    'perfilIdioma.idioma': function () {
      if (this.perfilIdioma.idioma.nome === 'LIBRAS') {
        this.perfilIdioma.leitura = { id: 'NAO_SE_APLICA', text: 'Não se Aplica' };
        this.perfilIdioma.escrita = { id: 'NAO_SE_APLICA', text: 'Não se Aplica' };
      } else if (this.perfilIdioma.leitura.id === 'NAO_SE_APLICA' && this.perfilIdioma.escrita.id === 'NAO_SE_APLICA') {
        this.perfilIdioma.leitura = null;
        this.perfilIdioma.escrita = null;
      }
    },
  },

  methods: {
    doAcao() {
      if (this.perfilIdioma.idioma == null || !this.perfilIdioma.idioma.isOutro) {
        this.perfilIdioma.nomeIdiomaOutro = null;
      }
      if (this.dialogProps.acao === 'editar') {
        perfilIdiomaRepository.update(this.perfilIdioma)
          .then((res) => {
            const perfilIdioma = res.data;
            const idx = this.perfil.idiomas.findIndex((p) => p.id === perfilIdioma.id);
            this.perfil.idiomas.splice(idx, 1, perfilIdioma);
            this.dialogProps.visibilidade = false;
            this.$store.dispatch('app/success', { response: res, message: 'Idioma editado com sucesso!' });
          });
      }
      if (this.dialogProps.acao === 'cadastrar') {
        this.perfilIdioma.perfil = this.perfil;
        perfilIdiomaRepository.create(this.perfilIdioma)
          .then((res) => {
            const perfilIdioma = res.data;
            this.perfil.idiomas.push(perfilIdioma);
            this.perfil.idiomas.sort((a, b) => a.nomeIdioma.localeCompare(b.nomeIdioma));
            this.dialogProps.visibilidade = false;
            this.$store.dispatch('app/success', { response: res, message: 'Idioma cadastrado com sucesso!' });
          });
      }
    },
  },
};
</script>
